const DESTINATION_TYPE_LABEL_TEXT = 'Qual é o tipo de endereço?';
const DESTINATION_TYPE_BUTTON_ID = 'destination-type-action-button';

export { DESTINATION_TYPE_LABEL_TEXT, DESTINATION_TYPE_BUTTON_ID };
